var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 96,
    viewBox: "0 0 112 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 31.9587V85.1613C112 91.1473 107.147 96 101.161 96H10.8387C4.85266 96 0 91.1473 0 85.1613V10.8387C0 4.85266 4.85266 0 10.8387 0H52.3232C55.8528 0 59.1614 1.71865 61.1909 4.6064L69.5594 16.5136C71.589 19.4014 74.8975 21.12 78.4271 21.12H101.161C107.147 21.12 112 25.9727 112 31.9587Z",
    fill: "#6682FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.3c8b66e1e02c448193375fc579ceae7d.svg";
export { ForwardRef as ReactComponent };